import React from 'react';
import { priceTiers } from '../mock';
import pricelistimg from "../assets/images/pricelistimg.jpg";

const PriceList = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Image Section */}
        <div className="mb-16">
          <img
            src={pricelistimg}
            alt="Salon Services"
            className="w-full h-[400px] object-cover rounded-lg shadow-xl"
          />
        </div>

        {/* Price List */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Service Pricelist</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {priceTiers.map((tier) => (
            <div
              key={tier.id}
              className="border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-all duration-300 hover:border-black"
            >
              <h4 className="text-lg font-bold text-gray-900 mb-2">{tier.title}</h4>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">{tier.description}</p>
              <p className="text-2xl font-bold text-black">{tier.price}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            className="bg-black hover:bg-gray-800 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
            onClick={() => alert('Viewing full price list...')}
          >
            View Full Price List
          </button>
        </div>
      </div>
    </section>
  );
};

export default PriceList;
